import React, { Component } from "react";
import PropTypes from "prop-types";
import Str from "shared/components/Str";

import {
	SECTIONS,
	QUESTION_ROW_INDEX,
	ADVERTISEMENT_ROW_INDEX,
	SECTIONS_TO_HIDE_IF_EMPTY,
} from "apps/discovery/util/consts";

import Section from "./Section";
import InterruptionWrapper from "./interruptions/InterruptionWrapper";
import Questions from "./interruptions/Questions";
import Blog from "./interruptions/Blog";
import Jobs from "./interruptions/Jobs";
import Advertisement from "./interruptions/Advertisement";

import "./Sections.scss";

class Sections extends Component {
	static propTypes = {
		sections: PropTypes.object.isRequired,
		sectionOrder: PropTypes.array.isRequired,
		mount: PropTypes.func.isRequired,
		getSection: PropTypes.func.isRequired,
		showDisplayAd: PropTypes.bool,
		showJobsAd: PropTypes.bool,
		isGettingQuestionMatches: PropTypes.bool,
		isGettingInterestMatches: PropTypes.bool,
	}

	static defaultProps = {
		showDisplayAd: true,
		showJobsAd: true,
		isGettingQuestionMatches: false,
		isGettingInterestMatches: false,
	}

	componentDidMount() {
		this.props.mount();
	}

	render() {
		const {
			sectionOrder,
			sections,
			getSection,
			showDisplayAd,
			showJobsAd,
			isGettingQuestionMatches,
			isGettingInterestMatches,
		} = this.props;

		return (
			<div className="discovery-sections">
				{sectionOrder.map((sectionId, i) => {
					if (!sections[sectionId] && SECTIONS_TO_HIDE_IF_EMPTY[sectionId]) {
						return false;
					}

					let isLoading = false;

					if (
						(sectionId === SECTIONS.important_questions && isGettingQuestionMatches) ||
						(sectionId === SECTIONS.interests && isGettingInterestMatches)
					) {
						isLoading = true;
					}

					return (
						<span key={sectionId}>
							<Section
								getSection={getSection}
								section={sections[sectionId]}
								isLoading={isLoading}
							/>
							{i === QUESTION_ROW_INDEX &&
								<InterruptionWrapper className="discovery-section--question">
									<Questions
										isWide={!showJobsAd}
									/>
									<Blog />
									{showJobsAd &&
										<Jobs />
									}
								</InterruptionWrapper>
							}
							{i === ADVERTISEMENT_ROW_INDEX && showDisplayAd &&
								<InterruptionWrapper className="discovery-section--ad">
									<Advertisement />
								</InterruptionWrapper>
							}
						</span>
					);
				})}
				<a href="/match" className="flatbutton big discovery-sections-more">
					<Str>Browse more matches</Str>
				</a>
			</div>
		);
	}
}

export default Sections;



// WEBPACK FOOTER //
// ./src/apps/discovery/components/Sections.jsx